import { visionURL } from "../config/environment";
import JsonApiService from "../services/jsonapiService";
import { useEffect, useState } from "react";

const complianceApiService = async (filter = {}) =>
  new JsonApiService("company_compliance", {
    baseUrl: `${visionURL}/admin_console/api`,
    credentials: "include",
    filter: filter
  });

export const useCompanyCompliance = filter => {
  const [isLoading, setIsLoading] = useState(false);
  const [compliance, setCompliance] = useState(null);
  const getCompanyCompliance = async () => {
    setIsLoading(true);
    const service = await complianceApiService({ course_type: filter.value });
    const response = await service
      .all()
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .catch(error => {
        setIsLoading(false);
        throw error;
      });
    setIsLoading(false);
    setCompliance(response);
  };

  useEffect(() => {
    getCompanyCompliance();
  }, [filter]);

  return { compliance, isLoading };
};
